import { FC, useEffect, useMemo } from 'react';
import {
  CarAllocation,
  CarAllocationResponseInCarOrder,
} from '../../../../../types/carAllocation';
import AllocationTableRow from '../AllocationTableRow';
import {
  Line,
  generateAllocationTask,
  getWorkRestTime,
} from '../allocationTableUtility';
import { useDispatch, useSelector } from 'react-redux';
import { setAllocationTasks } from '../../../../../redux/carAllocationEditSlice';
import { isTimeInTask } from '../../isTimeInTask';
import { AppDispatch, AppState } from '../../../../../redux/store';

type Props = {
  allocations: CarAllocationResponseInCarOrder | undefined;
  originDate: Date;
  setLastCalculatedAt: (lastCalculatedAt: string) => void;
  onClickDriverTime?: (
    elem: HTMLElement,
    allocation: CarAllocation,
    userId?: number | null,
    carId?: number | null
  ) => void;
};
const CarsTable: FC<Props> = ({
  allocations,
  originDate,
  setLastCalculatedAt,
  onClickDriverTime,
}) => {
  const readyToUpdate = useSelector(
    (state: AppState) => state.carAllocationEdit.tasksReadyToUpdate
  );
  useEffect(() => {
    const lastCalculatedAt = allocations?.lastCalculatedAt;
    if (lastCalculatedAt) {
      setLastCalculatedAt(lastCalculatedAt);
    }
  }, [allocations?.lastCalculatedAt]);
  const lines = useMemo(() => {
    return (allocations?.cars || []).flatMap<Line>((car) => {
      const toUpdate = readyToUpdate.find((rtu) => rtu.carId === car.carId);
      const carTitle = `${car.carCategory.name} / ${car.carNo}`;
      if (!car.drivers.length) {
        return {
          order: 'car',
          title: carTitle,
          allocations: [],
          carId: car.carId || undefined,
          userId: toUpdate?.userId,
          isAvailable: car.isAvailable,
        };
      }
      return car.drivers.flatMap((driver) => ({
        order: 'car',
        title: carTitle,
        sub: driver.driverName,
        restTime: getWorkRestTime(driver.workTimes[0]),
        allocations: driver.carAllocations,
        userId: driver.userId || undefined,
        carId: car.carId || undefined,
        isAvailable: car.isAvailable,
      }));
    });
  }, [allocations, readyToUpdate]);
  const dispatch = useDispatch<AppDispatch>();
  const tasks = useMemo(
    () =>
      lines.flatMap((l) =>
        generateAllocationTask(l.allocations, l.userId, l.carId)
      ),
    // readyToUpdate の変更による lines の再計算ではトリガさせたくないため、
    // この useMemo では使用しないが allocations 再計算条件としてのみ利用する
    [allocations]
  );
  useEffect(() => {
    dispatch(setAllocationTasks(tasks));
  }, [tasks]);

  return (
    <>
      {lines.map((line, i) => (
        <AllocationTableRow
          key={i}
          firstDate={i === 0}
          line={line}
          originDate={originDate}
          onClickTime={(elem, time) => {
            const found = line.allocations.find((alloc) =>
              isTimeInTask(time, alloc)
            );
            if (found)
              onClickDriverTime?.(elem, found, line.userId, line.carId);
          }}
        />
      ))}
    </>
  );
};

export default CarsTable;
